export default {
	"commonText": {
		"cancel": "Cancelar",
		"confirm": "Confirmar",
		"dueSoonTextDescription": "Vence hoy o ma\u00f1ana",
		"edit": "Editar",
		"parentAccountTestRestrictionMessage": "Debe haber iniciado sesi\u00f3n como estudiante para hacer una prueba.",
		"save": "Guardar",
		"title": "T\u00edtulo",
		"unauthorizedAccess": "Acceso no autorizado",
		"SMSDisclosure":"Al proporcionar su n\u00famero de tel\u00e9fono m\u00f3vil y aceptar recibir mensajes de texto, usted acepta recibir alertas por mensajes de texto relacionadas con la escuela de {district_desc} (asistencia, cambios de horario, cierres/demoras, actualizaciones importantes y comunicaciones escolares similares). La frecuencia de los mensajes puede variar. Pueden aplicarse cargos est\u00e1ndar por mensajes y datos. Responda STOP para cancelar o HELP para obtener ayuda. Su consentimiento no es obligatorio para recibir servicios escolares. Su n\u00famero de tel\u00e9fono m\u00f3vil no se vender\u00e1 ni se compartir\u00e1 con terceros para fines de mercadeo.",
		"SMSDisclosureDropdown":"Al proporcionar su n\u00famero de tel\u00e9fono m\u00f3vil y seleccionar 'S\u00ed' en Recibe mensajes de texto, usted acepta recibir mensajes de texto relacionados con la escuela de {district_desc} (asistencia, cambios de horario, cierres/demoras, actualizaciones importantes y comunicaciones escolares similares). La frecuencia de los mensajes puede variar. Pueden aplicarse cargos est\u00e1ndar por mensajes y datos. Responda STOP para cancelar o HELP para obtener ayuda. Su consentimiento no es obligatorio para recibir servicios escolares. Su n\u00famero de tel\u00e9fono m\u00f3vil no se vender\u00e1 ni se compartir\u00e1 con terceros para fines de mercadeo."
	},
	"MAIN_CONTENT": {
		"Announcements": {
			"labelAnnouncements": "Anuncios",
			"labelDistrictWideAnnouncement": "Anuncio para todo el distrito",
			"labelLess": "Menos",
			"labelMore": "M\u00e1s"
		},
		"App": {
			"genericErrorMessage": "No se pudo completar la solicitud de datos. Si los problemas persisten, comun\u00edquese con el servicio de asistencia.",
			"permissionDeniedMessage": "Autorizaci\u00f3n denegada. La cuenta no est\u00e1 asociada a ning\u00fan estudiante.",
			"titleCWP": "Sapphire Community Portal"
		},
		"AssessmentScores": {
			"assessment": "Evaluaci\u00f3n",
			"date": "Fecha",
			"grade": "Nota",
			"noAssessmentsMessage": "No hay informaci\u00f3n disponible sobre las evaluaciones para este estudiante.",
			"proficiency": "Competencia",
			"proficient": "Competente",
			"score": "Calificaci\u00f3n",
			"sideMenuAssessmentScoresLink": "Calificaciones de las evaluaciones"
		},
		"AssessmentScoresDetails": {
			"assessmentScoresWithColon": "Calificaciones de las evaluaciones: {name}",
			"column": "Columna",
			"columnDesc": "Desc. de la columna",
			"score": "Calificaci\u00f3n"
		},
		"AssignmentBin": {
			"attachedFiles": "Archivos adjuntos",
			"attachedFilesColon": "Archivos adjuntos:",
			"bytesMessage": "{name} ({size} Bytes)",
			"due": "Vencimiento: {date}",
			"gradeOverPoints": "{grade}/{points}",
			"hyphen": " - ",
			"mySubmissions": "Mis env\u00edos",
			"noAssignmentsInAssignmentBin": "No hay tareas en el contenedor de tareas",
			"seeFeedback": "Ver comentarios"
		},
		"AssignmentsCarousel": {
			"classPage_dueSoon": "Vence hoy o ma\u00f1ana ({count})",
			"reviewTestText": "Revisar prueba",
			"takeTestText": "Realizar prueba"
		},
		"Attendance": {
			"attendanceDescription": "Descripci\u00f3n de asistencia",
			"count": "Cantidad",
			"attendanceCodesCounts":"Cantidad por c\u00f3digo de asistencia",
			"comments": "Comentarios",
			"date": "Fecha",
			"day": "D\u00eda",
			"minutes": "Minutos",
			"noAbsenceRecords": "Este estudiante no tiene ausencias",
			"pendingForm":"Formulario de justificaci\u00f3n pendiente",
			"submitAbsenceForm":"Enviar justificaci\u00f3n de ausencia",
			"sideMenuAttendanceLink": "Asistencia",
			"youDoNotHaveAccessToThisStudentWithPeriod": "No tiene acceso a este estudiante."
		},
		"AttendanceSummary": {
			"absencesLabel": "Ausencias",
			"daysAllCaps": "D\u00cdAS",
			"daysAllLowercase": "d\u00edas",
			"earlyAllCaps": "TEMPRANO",
			"earlyAllLowercase": "temprano",
			"excusedWithColon": "Justificada:",
			"minAllCaps": "MIN",
			"minAllLowercase": "min",
			"tardyAllCaps": "TARDANZA",
			"tardyAllLowercase": "tardanza",
			"tardySlashEarlyDismissal": "Tardanza/Retiro anticipado",
			"unexcusedWithColon": "Injustificada:",
			"unlawfulWithColon": "Ilegal:"
		},
		"BuildingInformation": {
			"addressWithColon": "Direcci\u00f3n:",
			"buildingInformation": "Informaci\u00f3n del edificio",
			"faxWithColon": "Fax:",
			"phoneWithColon": "Tel\u00e9fono:",
			"staffTitle": "{title}:"
		},
		"BusingDetails": {
			"blockWithColon": "Bloque:",
			"bussingNotesWithColon": "Notas sobre el autob\u00fas:",
			"bussingStatusWithColon": "Estado del autob\u00fas:",
			"busWithColon": "{period} Autob\u00fas:",
			"carColorWithColon": "Color del autom\u00f3vil:",
			"carInformationWithColon": "Informaci\u00f3n del autom\u00f3vil:",
			"carNotesWithColon": "Notas sobre el autom\u00f3vil:",
			"licensePlateWithColon": "Matr\u00edcula:",
			"makeSlashModelWithColon": "Marca/Modelo:",
			"parkingInformationWithColon": "Informaci\u00f3n sobre el estacionamiento:",
			"permitWithColon": "Permiso:",
			"stopWithColon": "Parada:",
			"streetWithColon": "Calle:",
			"timeWithColon": "Hora:",
			"zoneWithColon": "Zona:"
		},
		"Calendar": {
			"lunchMenuModalTitle": "{date} - Men\u00fa del d\u00eda de {school}."
		},
		"ChangeStudentData": {
			"addressCity": "Ciudad de la direcci\u00f3n",
			"addressCounty": "Condado de la direcci\u00f3n",
			"addressLineOne": "L\u00ednea de direcci\u00f3n 1",
			"addressLineTwo": "L\u00ednea de direcci\u00f3n 2",
			"birthDate": "Fecha de nacimiento",
			"canSendTextMessages": "\u00bfPuede la escuela enviar mensajes de texto al n\u00famero de tel\u00e9fono del estudiante?",
			"canSendVoiceMessages": "\u00bfPuede la escuela enviar mensajes de voz al n\u00famero de tel\u00e9fono del estudiante?",
			"contactLivesWithStudent": "El contacto vive con el estudiante",
			"currentWithColon": "Actual: {choice}",
			"emailAddressOne": "Direcci\u00f3n de correo electr\u00f3nico 1",
			"emailAddressThree": "Direcci\u00f3n de correo electr\u00f3nico 3",
			"emailAddressTwo": "Direcci\u00f3n de correo electr\u00f3nico 2",
			"employer": "Empleador",
			"firstName": "Nombre",
			"householdPhone": "Tel\u00e9fono particular",
			"householdPhoneEmergencyCallOrder": "Orden de llamada de emergencia del tel\u00e9fono particular",
			"isPhoneUnlisted": "\u00bfEl n\u00famero de tel\u00e9fono del estudiante es privado?",
			"lastName": "Apellido",
			"middleName": "Segundo nombre",
			"occupation": "Ocupaci\u00f3n",
			"parentsGuardians": "Padres/tutores",
			"phoneFive": "Tel\u00e9fono 5",
			"phoneFiveCanSendTextMessages": "\u00bfPuede la escuela enviar mensajes de texto al n\u00famero de tel\u00e9fono 5?",
			"phoneFiveCanSendVoiceMessages": "\u00bfPuede la escuela enviar mensajes de voz al n\u00famero de tel\u00e9fono 5?",
			"phoneFiveEmergencyCallOrder": "Orden de llamada de emergencia del tel\u00e9fono 5",
			"phoneFiveExtension": "Extensi\u00f3n del tel\u00e9fono 5",
			"phoneFiveNumberUnlisted": "\u00bfEl n\u00famero de tel\u00e9fono 5 es privado?",
			"phoneFiveType": "Tipo del tel\u00e9fono 5",
			"phoneFour": "Tel\u00e9fono 4",
			"phoneFourCanSendTextMessages": "\u00bfPuede la escuela enviar mensajes de texto al n\u00famero de tel\u00e9fono 4?",
			"phoneFourCanSendVoiceMessages": "\u00bfPuede la escuela enviar mensajes de voz al n\u00famero de tel\u00e9fono 4?",
			"phoneFourEmergencyCallOrder": "Orden de llamada de emergencia del tel\u00e9fono 4",
			"phoneFourExtension": "Extensi\u00f3n del tel\u00e9fono 4",
			"phoneFourNumberUnlisted": "\u00bfEl n\u00famero de tel\u00e9fono 4 es privado?",
			"phoneFourType": "Tipo del tel\u00e9fono 4",
			"phoneOne": "Tel\u00e9fono 1",
			"phoneOneCanSendTextMessages": "\u00bfPuede la escuela enviar mensajes de texto al n\u00famero de tel\u00e9fono 1?",
			"phoneOneCanSendVoiceMessages": "\u00bfPuede la escuela enviar mensajes de voz al n\u00famero de tel\u00e9fono 1?",
			"phoneOneEmergencyCallOrder": "Orden de llamada de emergencia del tel\u00e9fono 1",
			"phoneOneExtension": "Extensi\u00f3n del tel\u00e9fono 1",
			"phoneOneNumberUnlisted": "\u00bfEl n\u00famero de tel\u00e9fono 1 es privado?",
			"phoneOneType": "Tipo del tel\u00e9fono 1",
			"phoneThree": "Tel\u00e9fono 3",
			"phoneThreeCanSendTextMessages": "\u00bfPuede la escuela enviar mensajes de texto al n\u00famero de tel\u00e9fono 3?",
			"phoneThreeCanSendVoiceMessages": "\u00bfPuede la escuela enviar mensajes de voz al n\u00famero de tel\u00e9fono 3?",
			"phoneThreeEmergencyCallOrder": "Orden de llamada de emergencia del tel\u00e9fono 3",
			"phoneThreeExtension": "Extensi\u00f3n del tel\u00e9fono 3",
			"phoneThreeNumberUnlisted": "\u00bfEl n\u00famero de tel\u00e9fono 3 es privado?",
			"phoneThreeType": "Tipo del tel\u00e9fono 3",
			"phoneTwo": "Tel\u00e9fono 2",
			"phoneTwoCanSendTextMessages": "\u00bfPuede la escuela enviar mensajes de texto al n\u00famero de tel\u00e9fono 2?",
			"phoneTwoCanSendVoiceMessages": "\u00bfPuede la escuela enviar mensajes de voz al n\u00famero de tel\u00e9fono 2?",
			"phoneTwoEmergencyCallOrder": "Orden de llamada de emergencia del tel\u00e9fono 2",
			"phoneTwoExtension": "Extensi\u00f3n del tel\u00e9fono 2",
			"phoneTwoNumberUnlisted": "\u00bfEl n\u00famero de tel\u00e9fono 2 es privado?",
			"phoneTwoType": "Tipo del tel\u00e9fono 2",
			"residentOfCounty": "Residente del condado",
			"schoolNotificationMessage": "La escuela recibir\u00e1 una notificaci\u00f3n sobre cualquier cambio realizado y tendr\u00e1 la oportunidad de revisarlos antes de que los cambios entren en vigor.",
			"sideMenuChangeStudentDataLink": "Cambiar los datos del estudiante",
			"state": "Estado",
			"studentAddressCity": "Ciudad de la direcci\u00f3n del estudiante",
			"studentAddressLineOne": "L\u00ednea de direcci\u00f3n del estudiante 1",
			"studentAddressLineTwo": "L\u00ednea de direcci\u00f3n del estudiante 2",
			"studentAddressState": "Estado de la direcci\u00f3n del estudiante",
			"studentAddressZip": "C\u00f3digo postal de la direcci\u00f3n del estudiante",
			"studentAddressZipExtend": "C\u00f3digo postal extendido de la direcci\u00f3n del estudiante",
			"studentEmailAddress": "Direcci\u00f3n de correo electr\u00f3nico del estudiante",
			"studentInformation": "Informaci\u00f3n del estudiante",
			"studentPhone": "Tel\u00e9fono del estudiante",
			"studentPhoneType": "Tipo de tel\u00e9fono del estudiante",
			"title": "T\u00edtulo",
			"township": "Municipio",
			"zipCode": "C\u00f3digo postal",
			"zipCodeExtension": "Extensi\u00f3n del c\u00f3digo postal"
		},
		"ClassGlossary": {
			"glossary": "Glosario",
			"studentClassGlossaryTitleCase": "Glosario de las clases de los estudiantes",
			"studentGroupGlossaryTitleCase": "Glosario del grupo de estudiantes"
		},
		"ClassGrades": {
			"assignmentDescription": "Descripci\u00f3n de las tareas",
			"assignments": "Tareas",
			"assignmentsAllCaps": "TAREAS",
			"assignmentSkills": "Habilidad(es) en las tareas",
			"categories": "CATEGOR\u00cdAS",
			"category": "Categor\u00eda",
			"classAverage": "Promedio de clases",
			"codeOverPoints": "{code}/{points}",
			"codeOverPointsPercent": "{code}/{points} ({percent})",
			"currentGrade": "Grado escolar en curso:",
			"currentGradeTitleCase": "Grado escolar en curso",
			"currentOverMaxPoints": "{current} / {max}",
			"date": "Fecha",
			"dateAssigned": "Fecha de asignaci\u00f3n",
			"dateDue": "Fecha l\u00edmite",
			"finalAverageNote": "*Es posible que los puntos totales sobre los puntos potenciales no reflejen el promedio final del estudiante si el maestro establece que las categor\u00edas deben representar un porcentaje espec\u00edfico del promedio del per\u00edodo de calificaci\u00f3n de un estudiante.",
			"generalComment": "Comentario general",
			"grade": "Nota",
			"gradesOverPointsAsterisk": "{grade} / {points}*",
			"markingPeriod": "Per\u00edodo de calificaci\u00f3n: {code}",
			"markingPeriodAbbreviation": "MP %",
			"maxExtraCredit": "Cr\u00e9dito adicional m\u00e1ximo",
			"noAssignmentGrades": "En la actualidad, este per\u00edodo de calificaci\u00f3n no tiene ninguna tarea con notas.",
			"noCategoryGrades": "En la actualidad, este per\u00edodo de calificaci\u00f3n no tiene ninguna categor\u00eda con notas.",
			"percent": "{percent}%",
			"points": "Puntos:",
			"scoresHigher": "Calificaciones m\u00e1s altas",
			"scoresLower": "Calificaciones m\u00e1s bajas",
			"scoresSame": "Calificaciones iguales",
			"showBy": "Mostrar por:",
			"skill": "Habilidad",
			"teacherComments": "Comentarios del maestro",
			"viewAssignmentTest": "Ver tarea/prueba",
			"weight": "Peso"
		},
		"classPage": {
			"AssignmentCarousel": {
				"classPage_due": "Vencimiento:",
				"classPage_noDueDate": "Sin fecha l\u00edmite",
				"classPage_points": "Puntos",
				"classPage_pointsWithPoints": "{points} puntos",
				"classPage_testClosesAt": "La prueba se cierra a las {time}",
				"classPage_uploadSubmission": "Cargar env\u00edo"
			},
			"AssignmentsList": {
				"classPage_action": "Acci\u00f3n",
				"classPage_assignmentName": "Nombre de la tarea",
				"classPage_dueDate": "Fecha l\u00edmite"
			},
			"ClassItems": {
				"noFilesMessage": "En este momento, no hay archivos en esta carpeta."
			},
			"ClassNav": {
				"classPage_classHome": "Inicio de clases"
			},
			"Header": {
				"classPage_classMenu": "Men\u00fa de clases",
				"teacherEmail": "correo electr\u00f3nico {teacher}"
			},
			"index": {
				"classPage_courseInfo": "Informaci\u00f3n del curso",
				"classPage_courseSections": "Subsecci\u00f3n",
				"classPage_currentGrades": "Grados escolares en curso",
				"classPage_gradesFootNote": "** Estas notas se consideran completas y es posible que no reflejen las tareas en el libro de notas del maestro.",
				"classPage_gridView": "Vista en cuadr\u00edcula",
				"classPage_listView": "Vista en lista",
				"classPage_reportsForStudent": "Publicaciones para {student}",
				"classPage_sliderView": "Vista de men\u00fa desplegable"
			}
		},
		"commonContent": {
			"classPage_upcomingAssignments": "Pr\u00f3ximas tareas",
			"classPage_upcomingAssignmentTotal": "total ({count})",
			"closeButton": "Cerrar",
			"currentHeaderLabel": "(actual)",
			"definition": "Definici\u00f3n",
			"goBack": "Volver",
			"homeHeaderLink": "Inicio",
			"invalidPermissions": "No tiene autorizaci\u00f3n para acceder a esta p\u00e1gina.",
			"newEntryTitleCase": "Nueva entrada",
			"newEntryTitleCaseWithIcon": "<i class=\"fas fa-plus\"></i> Nueva entrada",
			"newPosts": "Nuevas publicaciones",
			"next": "Siguiente",
			"noLabel": "No",
			"noStudentHasBeenSelectedWithPeriod": "No se ha seleccionado ning\u00fan estudiante.",
			"previous": "Anterior",
			"schoolLabel": "Escuela",
			"score": "Calificaci\u00f3n:",
			"sideMenuGradeLabel": "Grado:",
			"submit": "Enviar",
			"submitButton": "Enviar",
			"term": "Per\u00edodo",
			"yesLabel": "S\u00ed"
		},
		"confirmSubmission": {
			"confirmSubmission_submitMessage": "Haga clic en el bot\u00f3n Enviar a continuaci\u00f3n para guardar cualquier pregunta en progreso.",
			"confirmSubmission_timesUp": "Lo sentimos, \u00a1se acab\u00f3 el tiempo!",
			"pleaseConfirm": "Confirme...",
			"returnToQuestionLink": "Utilice el <a href=\"#question-nav\">men\u00fa de selecci\u00f3n de preguntas</a> para volver a una pregunta.",
			"returnToQuestionLinkBegin": "Utilice el ",
			"returnToQuestionLinkEnd": " para volver a una pregunta.",
			"returnToQuestionLinkMiddle": "men\u00fa de selecci\u00f3n de preguntas",
			"takeTester_answersNotSaved": "{count} respuesta(s) a\u00fan no guardadas. Puede volver a visitar la p\u00e1gina y guardar sus respuestas o, al enviar la prueba, se guardar\u00e1n todas las respuestas no guardadas.",
			"takeTester_extraCreditUnanswered": "{count} pregunta(s) de cr\u00e9dito adicional sin responder.",
			"takeTester_itAppearsThatYouHave": "Parece que usted tiene:",
			"takeTester_questionsUnanswered": "{count} pregunta(s) sin responder.",
			"takeTester_readyToSubmit": "Si est\u00e1 listo para enviar su prueba, haga clic en el bot\u00f3n a continuaci\u00f3n.",
			"takeTester_singleSittingMessage": "Una vez que env\u00ede su prueba, no podr\u00e1 cambiar ninguna respuesta."
		},
		"CourseRequestForms": {
			"actions": "Acciones",
			"chooseDesiredCourseInParenthese": "(Seleccione si la clase deseada no est\u00e1 en esta lista)",
			"courseNonRepeat": "*El estudiante ya ha realizado este curso.",
			"coursePreAssigned": "*Este curso fue previamente asignado y no se puede cancelar.",
			"courseRequestFormInstructionStepEight": "Imprima 2 copias del Formulario de selecci\u00f3n de cursos, 1 para sus registros y 1 para la escuela.",
			"courseRequestFormInstructionStepFive": "Para ver los \"Cursos optativos\", haga clic en el bot\u00f3n \"Expandir\" para abrir la pantalla y seleccionar los cursos de inter\u00e9s. Si desea un curso diferente a los que seleccion\u00f3, puede hacer clic a la derecha del curso de inter\u00e9s en la columna etiquetada \"alternativos\". Al terminar, puede \"contraer\" la pantalla y avanzar a otra \u00e1rea.",
			"courseRequestFormInstructionStepFour": "En el pr\u00f3ximo grado acad\u00e9mico tendr\u00e1 seleccionado \"Cursos obligatorios\".",
			"courseRequestFormInstructionStepNine": "Devuelva a la escuela una copia firmada",
			"courseRequestFormInstructionStepOne": "Elija el grado acad\u00e9mico adecuado arriba y haga clic en \"Completar la selecci\u00f3n de cursos\".",
			"courseRequestFormInstructionStepSeven": "En el Formulario de solicitud de cursos resultante, verifique la precisi\u00f3n y siga las instrucciones restantes.",
			"courseRequestFormInstructionStepSix": "Cuando haya completado sus selecciones, haga clic en \"Guardar la selecci\u00f3n de cursos\".",
			"courseRequestFormInstructionStepThree": "Todos los estudiantes deben seleccionar un curso de cada una de las disciplinas requeridas.",
			"courseRequestFormInstructionStepTwo": "Seleccione sus cursos haciendo clic en las casillas correspondientes. Si comete un error, simplemente puede quitar la marca de verificaci\u00f3n junto al curso que desee eliminar.",
			"courseTitle": "Asignatura",
			"credits": "Cr\u00e9ditos",
			"creditsWithColon": "Cr\u00e9ditos: {count}",
			"electiveCourses": "Asignaturas optativas",
			"failedPrerequisites": "* El estudiante no ha cumplido con los requisitos previos de este curso.",
			"fillOutCourseRequestForm": "Completar el formulario de solicitud de cursos",
			"mandatoryCourses": "Cursos obligatorios",
			"maximumRequirementsMet": "Se ha alcanzado el requisito m\u00e1ximo de cr\u00e9ditos. Se permite un m\u00e1ximo de {max} cr\u00e9ditos. En este momento, se han solicitado {total} cr\u00e9ditos.",
			"minimumCreditsNotMet": "No se ha alcanzado el requisito m\u00ednimo de cr\u00e9ditos. Se permite un m\u00ednimo de {min} cr\u00e9ditos. En este momento, se han solicitado {total} cr\u00e9ditos.",
			"moreDetailWithColon": "M\u00e1s detalles:",
			"rankAlternateCouses": "{courseid} - {coursedescription}",
			"rankAlternates": "Clasificar los cursos alternativos",
			"rankAlternatesCredits": "Cr\u00e9ditos: {credit}",
			"rankAlternatesInstructions": "Use las flechas para ordenar los cursos de su preferencia. 1 indica su primera opci\u00f3n, 2 la segunda, etc.",
			"rankAlternatesRank": "{rank}",
			"requiredCourses": "Cursos requeridos",
			"selectCourseRequestForm": "Seleccionar el Formulario de solicitud de cursos",
			"selectCourseRequestFormToComplete": "Seleccione el formulario de solicitud de cursos que desea completar de la lista a continuaci\u00f3n.",
			"specialRequestNotes": "Notas de solicitud especial",
			"youNeedToChoose": "Debe elegir al menos {min} curso(s) para {department}. Eligi\u00f3 {courses}"
		},
		"CoursesAndGradesList": {
			"courseTitle": "Asignatura",
			"currentGrade": "Grado escolar en curso",
			"duration": "Duraci\u00f3n",
			"periodDays": "Per\u00edodo (D\u00edas)",
			"room": "Aula",
			"showNonHyphenGradeClasses": "Mostrar clases sin notas",
			"sideMenuCoursesAndGradesLink": "Cursos y notas",
			"teacher": "Maestro"
		},
		"CurrentSchedule": {
			"rm": "RM",
			"showColorTitleCase": "Mostrar color",
			"showCourseSectionTitleCase": "Mostrar las secciones de las asignaturas",
			"showCourseTimesTitleCase": "Mostrar los horarios de las asignaturas",
			"sideMenuCurrentScheduleLink": "Horario actual"
		},
		"DataForm": {
			"absenceDate":"Fecha de ausencia",
			"absenceDateFrom":"Fecha de ausencia desde",
			"absenceDateTo":"Fecha de ausencia hasta",
			"absenceReason":"Motivo de ausencia",
			"addressOne": "Direcci\u00f3n 1",
			"addressTwo": "Direcci\u00f3n 2",
			"attachDocuments":"Adjuntar documentos",
			"attachmentWithColon": "Adjunto:",
			"attendanceDateMessage":"Las fechas deben ser mayores o iguales a hoy.",
			"attendanceNoDatesMessage":"No hay fechas v\u00e1lidas disponibles en el formulario; la fecha de finalizaci\u00f3n del a\u00f1o escolar es pasada y este formulario no permite fechas pasadas.",
			"back": "Volver",
			"cellPhone": "Tel\u00e9fono celular",
			"city": "Ciudad",
			"contactLivesWithStudent": "El contacto vive con el estudiante",
			"county": "Condado",
			"currentStepOfTotal": "Paso {current} de {total}",
			"email": "Correo electr\u00f3nico",
			"emergencyCallOrder": "Orden de llamada de emergencia",
			"employer": "Empleador",
			"ext": "Ext.",
			"faxNumber": "N\u00famero de fax",
			"formSubmitted": "\u00a1Formulario enviado!",
			"groupNumber": "N\u00famero de grupo",
			"homePhone": "Tel\u00e9fono residencial",
			"hospitalPreference": "Hospital de preferencia",
			"idNumber": "N\u00famero de identificaci\u00f3n",
			"insuranceCompany": "Compa\u00f1\u00eda de seguros",
			"middleName": "Segundo nombre",
			"number": "N\u00famero",
			"occupation": "Ocupaci\u00f3n",
			"pageNumber": "N\u00famero de localizador",
			"phoneNumberExtension": "Extensi\u00f3n del n\u00famero de tel\u00e9fono",
			"physicianFax": "Fax del m\u00e9dico",
			"physicianFaxExtension": "Extensi\u00f3n del fax del m\u00e9dico",
			"physicianFaxNumber": "N\u00famero de fax del m\u00e9dico",
			"physicianName": "Nombre del m\u00e9dico",
			"physicianPhone": "Tel\u00e9fono del m\u00e9dico",
			"policyNumber": "N\u00famero de p\u00f3liza",
			"receivesVoiceCalls": "Recibe llamadas de voz",
			"releaseStatus": "Divulgar estado",
			"saveCurrentProgressTitleCase": "Guardar progreso actual",
			"selectDates":"Seleccione las fechas que correspondan",
			"state": "Estado",
			"stepNumber": "{str}",
			"successfullySubmitted": "Ha enviado el siguiente formulario de forma correcta",
			"test": "{description}",
			"title": "T\u00edtulo",
			"titleWithFormName": "Formularios de datos del estudiante - {title}",
			"township": "Municipio",
			"type": "Tipo",
			"unlisted": "No incluido en la lista",
			"uploadFilesTitleCase": "Archivos cargados",
			"workPhone": "Tel\u00e9fono laboral",
			"zipCode": "C\u00f3digo postal",
			"zipCodeExt": "Extensi\u00f3n del c\u00f3digo postal",
			"zipCodeExtension": "Extensi\u00f3n del c\u00f3digo postal"
		},
		"Devices": {
			"activeSince": "Activo desde",
			"confirmLogoutMessage": "\u00bfEst\u00e1 seguro de que desea cerrar sesi\u00f3n en este dispositivo?",
			"device": "Dispositivo",
			"devices": "Dispositivos",
			"devicesDescription1Part1": "Ha utilizado la ",
			"devicesDescription1Part2": "opci\u00f3n en la pantalla de inicio de sesi\u00f3n de Sapphire y en este momento se encuentran conectados en los dispositivos a continuaci\u00f3n. Permanecer\u00e1 conectado hasta que cierre sesi\u00f3n en Sapphire en este dispositivo.",
			"devicesDescription2": "Algunos dispositivos y navegadores tienen configuraciones predeterminadas que podr\u00edan cerrar su sesi\u00f3n de forma autom\u00e1tica. Si experimenta cierres de sesi\u00f3n inesperados, verifique la configuraci\u00f3n de su dispositivo o navegador.",
			"lastUsed": "Usado por \u00faltima vez",
			"lastUsedAt": "Usado por \u00faltima vez en",
			"logOutDevice": "Cerrar sesi\u00f3n en el dispositivo",
			"manageDevices": "Administrar mis dispositivos conectados",
			"noDevicesMessage": "Actualmente no tiene dispositivos conectados con la opci\u00f3n \u201c\u00bfRecordarme?\u201d seleccionada.",
			"rememberMe": "\u00bfRecordarme?"
		},
		"Discipline": {
			"actionTaken": "Acciones que se tomaron",
			"date": "Fecha",
			"description": "Descripci\u00f3n",
			"incidentModalTitle": "{description} Incidente - Descripci\u00f3n oficial",
			"infractions": "Infracciones",
			"noIncidents": "No hay incidentes para mostrar.",
			"showDescription": "Mostrar descripci\u00f3n",
			"sideMenuDisciplineLink": "Disciplinario"
		},
		"Elective": {
			"alternate": "Alternativo"
		},
		"EssayQuestion": {
			"enterYourAnswer": "Ingrese su respuesta",
			"minMaxPointsMessage": "Ingrese entre {min} y {max} caracteres."
		},
		"Feedback": {
			"feedback": "Comentarios",
			"noFeedbackMessage": "En este momento, no hay comentarios para esta tarea."
		},
		"Fees": {
			"balanceOwed": "Saldo adeudado",
			"balanceOwedToSchoolLabel": "Saldo adeudado a la escuela: {fee}",
			"date": "Fecha",
			"fee": "Tarifa",
			"payment": "Payment",
			"feesWithDescription": "Tarifas: {description}",
			"showAllSchoolYears": "Mostrar todos los a\u00f1os escolares",
			"sideMenuFeesLink": "Tarifas",
			"type": "Tipo",
		},
		"FileCabinet": {
			"navPanelFileCabinet": "Archivador",
			"searchReturnedNoResults": "La b\u00fasqueda no arroj\u00f3 resultados."
		},
		"FilesList": {
			"datePosted": "Fecha de publicaci\u00f3n",
			"name": "Nombre"
		},
		"Forum": {
			"editTopic": "Editar tema",
			"message": "Mensaje",
			"newTopic": "Nuevo tema",
			"noTopicsMessage": "En este momento, no hay temas para este foro.",
			"topicHeader": "{label}:"
		},
		"General": {
			"changeMyAccountSettings": "Cambiar la configuraci\u00f3n de mi cuenta",
			"changeMyPassword": "Cambiar mi contrase\u00f1a",
			"changeMyPasswordForced": "Se restableci\u00f3 su contrase\u00f1a. Ingrese la contrase\u00f1a temporal de su correo electr\u00f3nico y su contrase\u00f1a nueva para continuar.",
			"changeMySecurityQuestion": "Cambiar mi pregunta de seguridad",
			"confirmNewPasswordStartCaseWithColon": "Confirmar la contrase\u00f1a nueva:",
			"general": "General",
			"generalAccountSettings": "Configuraci\u00f3n general de la cuenta",
			"languageSelectionTitle": "Seleccionar un idioma",
			"newPasswordStartCaseWithColon": "Contrase\u00f1a nueva:",
			"oldPasswordStartCaseWithColon": "Contrase\u00f1a anterior:",
			"passwordDoesntMatch": "Confirmar que la contrase\u00f1a no coincide",
			"passwordLengthMessage": "Al menos {length} caracteres: cuantos m\u00e1s caracteres, mejor.",
			"passwordMixMessage": "Una combinaci\u00f3n de letras y n\u00fameros.",
			"passwordRequirements": "La contrase\u00f1a debe tener las siguientes caracter\u00edsticas: ",
			"passwordSettingsStartCase": "Configuraci\u00f3n de la contrase\u00f1a",
			"pinWithColon": "PIN:",
			"securityAnswerStartCaseWithColon": "Respuesta de seguridad:",
			"securityQuestionSettingsStartCase": "Configuraci\u00f3n de la pregunta de seguridad",
			"securityQuestionStartCaseWithColon": "Pregunta de seguridad:",
			"selectLanguage": "Seleccionar un idioma:"
		},
		"GlossaryIndex": {
			"collapseAllTitleCase": "Contraer todo",
			"expandAllTitleCase": "Expandir todo"
		},
		"GlossaryResults": {
			"attachedFilesTitleCase": "Archivos adjuntos",
			"authorWithColon": "Autor:",
			"awaitingTeacherApproval": "Esperando la aprobaci\u00f3n del maestro.",
			"delete": "Eliminar",
			"edit": "Editar",
			"editTerm": "Editar-{term}",
			"teacherNote": "Nota del maestro"
		},
		"GlossarySearch": {
			"hideAllTotalEntries": "Ocultar las {count} entradas",
			"searchTermsTitleCase": "Buscar t\u00e9rminos",
			"viewAllTotalEntries": "Ver las {count} entradas"
		},
		"GraduationProgressReport": {
			"course": "Curso",
			"CourseWorkRequirements": "Requisitos de trabajo del curso",
			"CourseWorkRequirementsMet": "{student} ha cumplido con los {requirement} requisitos para la graduaci\u00f3n.",
			"CourseWorkRequirementsNotMet": "{student} a\u00fan no ha cumplido con el {requirement} para la graduaci\u00f3n",
			"credits": "Cr\u00e9ditos",
			"creditsAllCaps": "CR\u00c9DITOS",
			"creditsEarned": "Cr\u00e9ditos obtenidos",
			"creditsInProgress": "Cr\u00e9ditos en progreso",
			"creditsRequiredWithColon": "Cr\u00e9ditos requeridos:",
			"creditsStillNeededFirstLettersCapatilized": "Todav\u00eda se necesitan cr\u00e9ditos",
			"departmentRequirementsSatisfiedUponCompletion": "Requisito cumplido tras la finalizaci\u00f3n exitosa del trabajo en progreso del curso.",
			"finalGrade": "Nota final",
			"grade": "Nota",
			"requirement": "Requisito",
			"requirementHasBeenSatisfiedWithPeriod": "Este requisito se ha cumplido.",
			"sideMenuGraduationProgressLink": "Progreso de la graduaci\u00f3n",
			"status": "Estado",
			"summary": "Resumen",
			"totalCreditsNeededWithColon": "Se necesitan cr\u00e9ditos totales: {credits}",
			"totalCreditsRequirement": "Requisito de cr\u00e9ditos totales",
			"year": "A\u00f1o"
		},
		"Header": {
			"account": "Cuenta",
			"accountSettingsHeaderLabel": "Configuraci\u00f3n de la cuenta",
			"changeLanguage": "Cambiar idioma",
			"currentStudentProfileTitleCase": "Perfil actual del estudiante",
			"logoutHeaderLabel": "Cerrar sesi\u00f3n",
			"myStudentProfileTitleCase": "Mi perfil de estudiante",
			"selectAStudent": "Seleccionar un estudiante",
			"sideNavMyStudents": "Mis estudiantes",
			"switchToParentView": "Cambiar a la vista de los padre",
			"switchToStudentView": "Cambiar a la vista del estudiante"
		},
		"HelpButton": {
			"clickLinkMessage": "Haga clic en el enlace a continuaci\u00f3n para continuar con el centro de ayuda",
			"goToHelp": "Ir al centro de ayuda",
			"helpLink": "Ayuda",
			"note": "Nota: Para evitar esto la pr\u00f3xima vez, aseg\u00farese de habilitar las ventanas emergentes para Sapphire.",
			"popupBlocked": "Bloqueo de ventanas emergentes detectado."
		},
		"HomePage": {
			"actionsTakenLabel": "Acciones que se tomaron",
			"attendanceDescriptionLabel": "Descripci\u00f3n de asistencia",
			"balanceOwedToSchoolLabelNoProp": "Saldo adeudado a la escuela: ",
			"classLabel": "Clase",
			"commentsLabel": "Comentarios",
			"completed": "{percent} completado",
			"CovidSurveyMessage": "Si no lo ha hecho hoy, complete el ",
			"dateLabel": "Fecha",
			"dayLabel": "D\u00eda",
			"formsAwaitingCompletionLabel": "Formularios a la espera de finalizaci\u00f3n",
			"formStarted": "(Formulario iniciado)",
			"gradeMarkingPeriodLabel": "Nota del per\u00edodo de calificaci\u00f3n",
			"graduationProgressLabel": "Progreso de la graduaci\u00f3n",
			"infractionsLabel": "Infracciones",
			"inProgress": "{percent} en progreso",
			"interactiveSchedulesLabel": "Horarios interactivos",
			"itemLabel": "Art\u00edculo",
			"localeSaveError": "Error al guardar la opci\u00f3n del lugar.",
			"lunchMenuLabel": "Men\u00fa del d\u00eda",
			"MinutesLabel": "Minutos",
			"nextYearCourseRequestFormButton": "El formulario de solicitud de cursos del pr\u00f3ximo a\u00f1o est\u00e1 disponible",
			"noAttendanceFromPastSevenDaysLabel": "Sin registro de asistencia de los \u00faltimos 7 d\u00edas.",
			"noDisciplineFromThePastSevenDays": "Sin registro disciplinario de los \u00faltimos 7 d\u00edas.",
			"noGradeUpdatesFromThePastSevenDays": "Sin registro de actualizaciones de notas de los \u00faltimos 7 d\u00edas",
			"nothingForThisWeek": "Nada para esta semana.",
			"noTransactionsFromThePastSevenDaysLabel": "Sin registro de transacciones de los \u00faltimos 7 d\u00edas.",
			"postedLabel": "Publicado",
			"recentAttendanceLabel": "Asistencia reciente",
			"recentClassPostingsLabel": "Publicaciones recientes de la clase",
			"recentDisciplineLabel": "Incidentes disciplinarios recientes",
			"recentFeesLabel": "Tarifas recientes",
			"recentGradeUpdatesLabel": "Actualizaciones recientes de las notas",
			"recentSchoolPostingsLabel": "Publicaciones escolares recientes",
			"seeAllLabel": "Ver todo",
			"showingAttendanceFromPastSevenDaysLabel": "Mostrar la asistencia de los \u00faltimos 7 d\u00edas.",
			"showingDisciplineFromThePastSevenDays": "Mostrar los incidentes disciplinarios de los \u00faltimos 7 d\u00edas.",
			"showingGradeUpdatesFromThePastSevenDays": "Mostrar las actualizaciones de notas de los \u00faltimos 7 d\u00edas",
			"showingLabel": "Mostrar",
			"showingTransactionsFromThePastSevenDaysLabel": "Mostrar las transacciones de los \u00faltimos 7 d\u00edas.",
			"teacherLabel": "Maestro",
			"transactionsLabel": "Transacciones",
			"typeLabel": "Tipo",
			"upcomingAssignments": "Pr\u00f3ximas tareas",
			"updatedLabel": "Actualizado",
			"windowOpenUntilLabel": "Ventana abierta hasta"
		},
		"IncompleteForms": {
			"clearFormStartCase": "Borrar formulario",
			"formsAwaitingCompletionTitleCase": "Formularios a la espera de finalizaci\u00f3n"
		},
		"InteractiveScheduler": {
			"allDepartments": "Todos los departamentos",
			"courseConflictMessage": "\u00a1Ups! \u00a1Parece que el curso seleccionado entra en conflicto con otro curso!",
			"empty": "(vac\u00edo)",
			"filterBy": "Filtrar por:",
			"loadingMessage": "Cargando la configuraci\u00f3n de horario...",
			"periodDays": "Per\u00edodos/d\u00edas",
			"print": "Imprimir",
			"selectScheduleToAccess": "Seleccione el horario al que desea acceder.",
			"showCourseDesctions": "Mostrar las descripciones de los cursos",
			"showUnavailableClasses": "Mostrar las clases no disponibles",
			"sideMenuInteractiveSchedulerLink": "Programador interactivo",
			"useThisScreenToChangeClassSchedule": "Use esta pantalla para realizar cambios en el horario de su clase."
		},
		"LTILaunch": {
			"go": "Ir"
		},
		"LunchMenus": {
			"lunchMenusLabel": "Men\u00fas del d\u00eda"
		},
		"MatchingQuestion": {
			"correctAnswer": "Respuesta correcta:",
			"instruction": "Una cada indicaci\u00f3n con su respuesta correcta.",
			"pointsPossible": "{points} puntos posibles",
		},
		"MultipleChoiceQuestion": {
			"incorrectMessage": "\u00a1Las respuestas incorrectas quitar\u00e1n puntos!",
			"pointsPossible": "{points} puntos posibles",
			"selectAllMessage": "Seleccione TODAS las respuestas correctas.",
			"selectCorrectMessage": "Seleccione la respuesta correcta."
		},
		"Notifications": {
			"addEmail": "Agregar correo electr\u00f3nico",
			"addNewStep": "Agregar nuevo paso",
			"addSMSTextMessage": "Agregar mensaje de texto SMS",
			"addVoiceCall": "Agregar llamada de voz",
			"answeredBy": "Respondido por:",
			"broadcastHistoryText": "Historia de la transmisi\u00f3n",
			"broadcastsTabName": "Historia de mi transmisi\u00f3n",
			"contactAt": "Comun\u00edquese al",
			"custom": "Personalizado:",
			"customMessage": "El flujo de trabajo se personaliza por tipo de suscripci\u00f3n; si no se proporciona un flujo de trabajo, el sistema recurrir\u00e1 al valor predeterminado del usuario y luego al valor predeterminado del sistema.",
			"defaultEmailText": "Idioma del mensaje de correo electr\u00f3nico predeterminado:",
			"defaultNotifications": "Flujo de trabajo de la notificaci\u00f3n predeterminado",
			"defaultSMSText": "Idioma del texto SMS predeterminado:",
			"defaultVoiceText": "Idioma de la llamada de voz predeterminado:",
			"dirtyPageMessage": "No se han guardado uno o m\u00e1s cambios. \u00bfEst\u00e1 seguro de que desea salir sin guardar?",
			"districtAnnouncements": "Anuncios del distrito/de la escuela",
			"duration": "Duraci\u00f3n:",
			"email": "Correo electr\u00f3nico",
			"emailAllCaps": "CORREO ELECTR\u00d3NICO",
			"emailWithColon": "Correo electr\u00f3nico:",
			"globalSetting": "Configuraci\u00f3n global",
			"languageSettings": "Configuraci\u00f3n de idioma",
			"myDefault": "Mi valor predeterminado:",
			"myDefaultMessageText": "El flujo de trabajo se basa en el flujo de trabajo de la suscripci\u00f3n predeterminado y definido por el usuario.",
			"noAudioSupport": "Su navegador no admite el elemento de audio.",
			"noBroadcastMessage": "No se encontraron transmisiones en los \u00faltimos 3 meses",
			"notifications": "Notificaciones",
			"notificationsTabName": "Flujo de trabajo de la notificaci\u00f3n",
			"notificationsText": "Suscripciones a las notificaciones de Sapphire",
			"phone": "Tel\u00e9fono:",
			"phoneMessage": "Mensaje telef\u00f3nico:",
			"receiveNotificationsForTheFollowing": "Recibir una notificaci\u00f3n por correo electr\u00f3nico cuando se publiquen los siguientes elementos:",
			"showEnglish": "Mostrar ingl\u00e9s",
			"sms": "SMS",
			"smsTextMessage": "Mensaje de texto SMS",
			"smsTextMessageWithColon": "Mensaje de texto SMS:",
			"studentClassReports": "Informes del estudiante/de la clase",
			"subjectLineWithColon": "L\u00ednea de asunto:",
			"subscribed": "Suscrito",
			"systemDefault": "Predeterminado por el sistema:",
			"systemDefaultMessageText": "El flujo de trabajo se basa en la configuraci\u00f3n predeterminada del flujo de trabajo del sistema Sapphire.",
			"turnOffNotificationsViaEmail": "Activar y desactivar las notificaciones por correo electr\u00f3nico",
			"voiceCall": "Llamada de voz"
		},
		"NumericQuestion": {
			"acceptableAnswers": "Respuesta(s) aceptables:",
			"instructionMessage": "Ingrese su respuesta num\u00e9rica",
			"numericalLabel": "{first} - {second}",
			"points": "{points} puntos"
		},
		"ParentHomePage": {
			"emailWithColon": "Correo electr\u00f3nico:",
			"goToMyBackpack": "Ir a My Backpack para {name}",
			"homePhoneNumberTitleCaseWithColon": "N\u00famero de tel\u00e9fono residencial:",
			"myStudents": "Mis estudiantes",
			"quickViewTitleCase": "Vista r\u00e1pida",
			"schoolContactTitleCaseWithColon": "Contacto escolar:"
		},
		"Post": {
			"backToTopics": "Volver a Temas",
			"comment": "Comentario",
			"editPost": "Editar publicaci\u00f3n",
			"forumLoadedAt": "El foro se actualiz\u00f3 por \u00faltima vez a las {date}",
			"hideReplies": "Ocultar respuestas",
			"newComment": "Nuevo comentario",
			"placeholder": "ASUNTO: {title}",
			"refresh": "Actualizar",
			"reply": "Responder",
			"showNReplies": "Mostrar {count} respuestas",
			"showOneReply": "Mostrar 1 respuesta"
		},
		"ProgressBar": {
			"completed": "{percent}\u00a0% completado",
			"inProgress": "{percent}\u00a0% en progreso"
		},
		"ProgressReportDepartments": {
			"inProgress": "En progreso",
			"noCoursesQualifyRequirementWithPeriod": "En este momento, ning\u00fan curso califica para este requisito."
		},
		"ProgressReportYears": {
			"schoolYearWithColon": "A\u00f1o escolar: {year}"
		},
		"QuestionGroup": {
			"message": "Hay informaci\u00f3n adicional para esta pregunta."
		},
		"QuestionSummary": {
			"correct": "Correcto",
			"incorrect": "Incorrecto",
			"is": "es",
			"partiallyCorrect": "Parcialmente correcto",
			"ptsEarned": "puntos obtenidos",
			"yourAnswer": "Su respuesta"
		},
		"ReportFiles": {
			"datePosted": "Fecha de publicaci\u00f3n",
			"name": "Nombre",
			"navPanelLetters": "Cartas",
			"navPanelProgressReports": "Informes de progreso",
			"navPanelReportCards": "Bolet\u00edn de calificaciones",
			"navPanelTranscript": "Transcripci\u00f3n",
			"school": "Escuela"
		},
		"Required": {
			"tootTipMessage": "Solo puede elegir {required} curso(s) para {description}. Eligi\u00f3 {count}"
		},
		"ShortFillQuestion": {
			"enterMessage": "Ingrese su respuesta corta",
			"ptsPossible": "puntos posibles"
		},
		"SidePanel": {
			"navPanelReports": "Informes",
			"sideMenuCollapseLabel": "Contraer men\u00fa",
			"sideMenuCourseRequestFormLink": "Formulario de solicitud de cursos",
			"sideMenuExpandLabel": "Expandir men\u00fa",
			"sideMenuMyBackpackHeader": "My Backpack",
			"sideMenuReportsLink": "Informes"
		},
		"StudentCalendar": {
			"day": "d\u00eda",
			"dueDateTitleCaseWithColon": "Fecha l\u00edmite:",
			"list": "lista",
			"month": "mes",
			"sideMenuStudentCalendarLink": "Calendario del estudiante",
			"startDateTitleCaseWithColon": "Fecha de inicio:",
			"today": "hoy",
			"week": "semana"
		},
		"StudentDataForms": {
			"approvedMessageText": "Este formulario ha sido aprobado.",
			"approvedTitleCase": "Aprobado",
			"completedTitleCase": "Completado",
			"daysTitleCase": "D\u00edas",
			"declinedMessageText": "Este formulario ha sido rechazado:",
			"declinedTitleCase": "Rechazado",
			"descriptionLabel": "Descripci\u00f3n",
			"formLabel": "Formulario",
			"formsAwaitingCompletionTitleCase": "Formularios a la espera de finalizaci\u00f3n",
			"lastSubmittedTitleCase": "\u00daltimo enviado",
			"lastTitleCase": "\u00daltimo",
			"noFormsAwaitingCompletion": "No hay formularios a la espera de finalizaci\u00f3n",
			"onDemandFormsTitleCase": "Formularios a pedido",
			"openUntilTitleCase": "Abierto hasta",
			"pendingFormLabel": "Formularios pendientes",
			"pendingMessageText": "Este formulario est\u00e1 a la espera de aprobaci\u00f3n.",
			"readonlyMessageText":"Este formulario no acepta env\u00edos de administradores.",
			"recentFormLabel": "Formularios completados recientemente",
			"resetFormTitleCase": "Borrar formulario",
			"resultsMessageText": "No se han devuelto formularios recientes",
			"sideMenuStudentDataFormsLink": "Formularios de datos del estudiante",
			"status": "Estado",
			"submittedFormLabel": "Formularios enviados",
			"submittedTitleCase": "Enviado",
			"submissionsTitleCase": "Env\u00edos"
		},
		"StudentInformation": {
			"combinationWithColon": "Combinaci\u00f3n:",
			"counselorWithColon": "Consejero:",
			"homeroomWithColon": "Aula principal del estudiante:",
			"learningGroup": "Grupo de aprendizaje:",
			"locationWithColon": "Ubicaci\u00f3n:",
			"lockerWithColon": "Casillero:",
			"sideMenuGradeLabelEnrolled": "{school} - Grado: {grade}",
			"sideMenuGradeLabelNotEnrolled": "{school} - Grado: {grade} - No est\u00e1 inscrito actualmente",
			"sideMenuStudentInformationLink": "Informaci\u00f3n del estudiante",
			"teacherWithColon": "Maestro:",
			"team": "Equipo:"
		},
		"Students": {
			"addAnotherStudent": "Agregar otro estudiante",
			"birthdayWithColon": "Cumplea\u00f1os:",
			"firstNameWithColon": "Nombre:",
			"lastNameWithColon": "Apellido:",
			"manageStudentsTitleCase": "Administrar estudiantes",
			"portalAccessInformationalText": "Si desea solicitar acceso al Portal para un estudiante diferente que ya est\u00e1 inscrito en el distrito escolar, haga clic en el bot\u00f3n a continuaci\u00f3n.",
			"requestAccessToOterStudents": "Solicitar acceso para otros estudiantes",
			"requestAccessToOtherStudentsTitleCase": "Solicitar acceso para otros estudiantes",
			"schoolWithColon": "Escuela:",
			"studentHasAnAccount": "El estudiante tiene una cuenta",
			"students": "Estudiantes",
			"studentsDetailOnWhatToEnter": "Ingrese el nombre, la fecha de nacimiento, el grado y la escuela a continuaci\u00f3n para los estudiantes a los que desea acceder. Se enviar\u00e1 una solicitud al distrito escolar para su aprobaci\u00f3n.",
			"submitRequestTitleCase": "Enviar solicitud"
		},
		"Submission": {
			"addSubmission": "Agregar env\u00edo",
			"assignmentBin": "Contenedor de tareas",
			"assignmentBinClosed": "* En este momento, esta tarea no est\u00e1 abierta para env\u00edos.",
			"dirtyPageAssignmentMessage": "Esta tarea ha sido modificada. \u00bfEst\u00e1 seguro de que desea salir sin guardar los cambios?",
			"oneFileUpload": "Solo se permite cargar un archivo",
			"onlyOneSubmission": "* Ha alcanzado el l\u00edmite de 1 env\u00edo para esta tarea.",
			"submittedFiles": "Archivos enviados",
			"textSubmission": "Env\u00edo de textos",
			"textSubmissionColon": "Env\u00edo de textos:"
		},
		"testButtons": {
			"takeTester_changeAnswer": "Cambiar respuesta",
			"takeTester_flagQuestion": "Marcar pregunta",
			"takeTester_saveAnswer": "Guardar respuesta",
			"takeTester_submitTest": "Enviar prueba"
		},
		"testReviewer": {
			"extraCredit": "Cr\u00e9dito adicional",
			"points": "puntos",
			"reviewMyTest": "Revisar mi prueba",
			"scoreOfTotalScore": "{score} de {total}",
			"scoreOfTotalScorePossible": "{score} de {total} posible",
			"scoreOutOfTotal": "{score} / {total}",
			"started": "Iniciado",
			"submitted": "Enviado",
			"takeTester_finishedReview": "Cuando termine de revisar la prueba, haga clic en el bot\u00f3n para cerrar esta ventana."
		},
		"testTaker": {
			"loading": "Cargando...",
			"points": "{points} puntos",
			"pointsPossible": "{points} puntos posibles",
			"questionNumber": "Pregunta {number}",
			"takeTester_allowChange": "Los estudiantes no podr\u00e1n cambiar sus respuestas durante esta sesi\u00f3n de prueba.",
			"takeTester_availableForReview": "Estar\u00e1 disponible para su revisi\u00f3n despu\u00e9s de que se corrijan todas las pruebas.",
			"takeTester_closeWindow": "Cerrar ventana",
			"takeTester_duration": "Duraci\u00f3n",
			"takeTester_immediateFeedback": "Una vez que se env\u00eden las respuestas, se mostrar\u00e1n los comentarios.",
			"takeTester_mins": "{time} min",
			"takeTester_minsLeft": "Minutos restantes",
			"takeTester_singleSession": "Debe completar esta prueba en una sola sesi\u00f3n",
			"takeTester_startNow": "Comenzar prueba ahora",
			"takeTester_submitted": "\u00a1Su prueba ha sido enviada!",
			"takeTester_testEndedMessage": "Se ha enviado esta prueba y ya no podr\u00e1 cambiar ninguna respuesta.",
			"takeTester_testExpired": "Esta prueba ya no est\u00e1 disponible.",
			"takeTester_windowCloses": "La ventana se cierra",
			"takeTester_windowOpen": "La ventana se abre"
		},
		"TimeTraveller": {
			"weekOfWithColon": "Semana de:"
		},
		"trueFalseQuestion": {
			"questionMessage": "Seleccione Verdadero o Falso"
		}
	}
};
